/**
 * @generated SignedSource<<f2755fc7cc3fb0d898031a7d7bc64f52>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesPrintTypesQuery$variables = Record<PropertyKey, never>;
export type composerQueriesPrintTypesQuery$data = {
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
};
export type composerQueriesPrintTypesQuery = {
  response: composerQueriesPrintTypesQuery$data;
  variables: composerQueriesPrintTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypeID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesPrintTypesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PrintTypesConnection",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PrintType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "printTypes(first:200)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerQueriesPrintTypesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PrintTypesConnection",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PrintType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "printTypes(first:200)"
      }
    ]
  },
  "params": {
    "cacheID": "e61070cd01898434abecf4f1905de702",
    "id": null,
    "metadata": {},
    "name": "composerQueriesPrintTypesQuery",
    "operationKind": "query",
    "text": "query composerQueriesPrintTypesQuery {\n  printTypes(first: 200) {\n    edges {\n      node {\n        printTypeID\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee70f8c3cc6e5edc3d060c637c1eb071";

export default node;
